const PhoneSvg = ({ size = '14px' }) => (
  <svg
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`size-[${size}]`}
  >
    <path
      d="M3.8857 1.7194L4.4237 1.5474C4.9282 1.3864 5.4672 1.6469 5.6832 2.1559L6.1132 3.1699C6.3002 3.6114 6.1962 4.1309 5.8562 4.4539L4.9087 5.35291C4.9672 5.8909 5.1482 6.42041 5.4512 6.94141C5.73893 7.44547 6.12488 7.88668 6.5862 8.2389L7.7242 7.85891C8.1552 7.71541 8.6252 7.8809 8.8892 8.2694L9.5057 9.17441C9.8132 9.62641 9.7577 10.2494 9.3762 10.6324L8.9677 11.0429C8.5607 11.4514 7.9792 11.5999 7.4417 11.4319C6.1717 11.0359 5.0052 9.8604 3.9402 7.90541C2.8737 5.9474 2.4972 4.2854 2.8112 2.9214C2.9432 2.3474 3.3517 1.8899 3.8857 1.7194Z"
      fill="black"
    />
  </svg>
);

export default PhoneSvg;
